export type EventHandler = (event?: any) => void;

export type EventHandlerList = EventHandler[];

export interface IEventHandlerMap {
  [type: string]: EventHandlerList;
}

export default class EventEmitter {
  private all: IEventHandlerMap;

  constructor(allAsParam?: IEventHandlerMap) {
    this.all = allAsParam || {};
  }

  emit(type: string, event: any): void {
    (this.all[type] || []).forEach(handler => {
      handler(event);
    });
  }

  off(type: string, handler: EventHandler): void {
    if (this.all[type]) {
      this.all[type] = this.all[type].filter(h => h !== handler);
    }
  }

  on(type: string, handler: EventHandler): void {
    (this.all[type] || (this.all[type] = [])).push(handler);
  }
}
